import {Nullable} from "../../common/types/nullable";
import {includesAuthScope} from "../../features/user/accessRightChecks";
import {User} from "../../features/user/user";
import {FEATURE_FLAGS, FeatureFlagName} from "./featureFlags";
import {Env} from "./types";

/**
 * Test if feature is now accessible (to the user)
 * @param featureFlagName
 * @param user required if rule includes userIds or authScopes
 * @returns
 */
export const canViewFeature = (
  featureFlagName: FeatureFlagName,
  user: Nullable<User> = null,
): boolean => {
  const rule = FEATURE_FLAGS[featureFlagName];
  if (typeof rule === "boolean") return rule;

  const envMatch = rule.excludeEnv
    ? !rule.excludeEnv.includes(
        process.env.REACT_APP_HOST_ENVIRONMENT_NAME as Env,
      )
    : true;

  const userIdMatch = user
    ? rule.userIds
      ? rule.userIds.includes(user.id)
      : true
    : true;

  const userRoleMatch = user
    ? rule.authScopes
      ? includesAuthScope(user, rule.authScopes)
      : true
    : true;

  return envMatch && userIdMatch && userRoleMatch;
};
